/* eslint-disable no-param-reassign */
import React, { useEffect, useRef } from 'react';
import FontFaceObserver from 'fontfaceobserver';
import { useSignatureFonts } from './useSignatureFonts';
import './MeasureTextPolyfill';

const SignatureText = React.forwardRef((props, ref) => {
  const { displayWidth, displayHeight, actualWidth, actualHeight, color, text, fontName, showLine } = props;
  const canvasRef = useRef();
  const font = useSignatureFonts().find((x) => x.name === fontName);
  const fontFamily = font ? font.fontFamily : '';

  ref.current = {
    toDataURL: async () => {
      const imageCanvas = document.createElement('canvas');
      imageCanvas.width = actualWidth;
      imageCanvas.height = actualHeight;
      await drawText(imageCanvas, text, fontFamily, color, actualWidth, actualHeight);
      return imageCanvas.toDataURL();
    }
  };

  useEffect(() => {
    clearCanvas(canvasRef.current, displayWidth, displayHeight);
    if (showLine) {
      drawLine(canvasRef.current, displayWidth, displayHeight);
    }
    drawText(canvasRef.current, text, fontFamily, color, displayWidth, displayHeight);
  }, [text, fontFamily, color, displayWidth, displayHeight]);

  return <canvas width={displayWidth} height={displayHeight} ref={canvasRef} style={{ position: 'relative' }} />;
});

export default SignatureText;

function clearCanvas(canvas, width, height) {
  const context = canvas.getContext('2d');
  context.clearRect(0, 0, width, height);
}

async function drawText(canvas, text, fontFamily, color, width, height) {
  const topPadding = height * 0.05;
  const horizontalPadding = width * 0.05;
  const maxWidth = width - horizontalPadding * 2;
  const textBaselineY = (height / 4) * 3;

  const context = canvas.getContext('2d');
  context.textAlign = 'left';
  context.textBaseline = 'alphabetic';

  if (text) {
    const fontObserver = new FontFaceObserver(fontFamily);
    await fontObserver.load();
    context.fillStyle = color;
    context.font = `10px ${fontFamily}`;
    let measurement = context.measureText(text);
    let fontSize = Math.min(maxWidth / (Math.abs(measurement.actualBoundingBoxLeft / 10) + Math.abs(measurement.actualBoundingBoxRight / 10)), height);
    context.font = `${fontSize}px ${fontFamily}`;

    measurement = context.measureText(text);

    while (
      (measurement.actualBoundingBoxAscent > textBaselineY - topPadding || measurement.actualBoundingBoxDescent > height - textBaselineY) &&
      fontSize > 1
    ) {
      fontSize--;
      context.font = `${fontSize}px ${fontFamily}`;
      measurement = context.measureText(text);
    }
    context.fillText(text, horizontalPadding + measurement.actualBoundingBoxLeft, textBaselineY);
  }
}

export function drawLine(canvas, width, height) {
  const horizontalPadding = width * 0.05;
  const textBaselineY = (height / 4) * 3;

  const context = canvas.getContext('2d');
  context.strokeStyle = '#b6c1c6';
  context.beginPath();
  context.moveTo(horizontalPadding, textBaselineY);
  context.lineTo(width - horizontalPadding, textBaselineY);
  context.stroke();
}
